import axios from 'axios';

interface IChangePassword {
  client_id?: string;
  email?: string;
  connection: string;
}

const changePassword = async (data: IChangePassword): Promise<void> => {
  await axios.post(
    `https://${process.env.REACT_APP_AUTH0_DOMAIN}/dbconnections/change_password`,
    data,
  );
};

export { changePassword };
